import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

const foodAlcoholList = (props) => {

  return (
    <DataTable
      value={props.foodAlcohols}
      paginator={true}
      lazy={true}
      rows={props.rows}
      totalRecords={props.totalRecords}
      onPage={(event) => props.onPageClick(event)}
      first={props.first}
      dataKey='foodAlcoholId'
    //loading={props.isLoading}	
    >
      <Column header="Name"
        body={(rowData, column) =>
          rowData && rowData.foodAlcoholContent && rowData.foodAlcoholContent.length ?
            rowData.foodAlcoholContent
              .filter(x => typeof x.foodAndAlcoholName === 'string' && x.foodAndAlcoholName.length > 0)
              .map(r => r.foodAndAlcoholName)
              .join(' / ')
            : null
        }
      />
      <Column
        header="Actions"
        style={{ textAlign: "center", width: "8em" }}
        body={(rowData, column) =>
          <div>
            <Button
              type="button"
              icon="pi pi-pencil"
              className="p-button-warning"
              tooltip="Edit"
              tooltipOptions={{ position: 'top' }}
              style={{ marginRight: ".5em" }}
              onClick={() => props.editClick(rowData.foodAlcoholId)}
            />
            <Button
              type="button"
              icon="pi pi-trash"
              className="p-button-danger"
              tooltip="Delete"
              tooltipOptions={{ position: 'top' }}
              onClick={() => props.deleteClick(rowData.foodAlcoholId)}
            />
          </div>
        }
      />
    </DataTable>
  )
}

export default foodAlcoholList;
